// extracted by mini-css-extract-plugin
export default {"icon":"BesInfo_icon__V5g0t","infoText":"BesInfo_infoText__fo0vj","infoTextTitle":"BesInfo_infoTextTitle__Gf-Gs","container":"BesInfo_container__B6xNO"};